module.exports = __webpack_public_path__ + "img/TXPK10.png";